"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var delay_1 = __importDefault(require("delay"));
var __1 = require("../");
var User = /** @class */ (function () {
    function User(id, type, profileId, userSub) {
        var _this = this;
        this.fetchDriver = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // TODO: connect to endpoint
                    return [4 /*yield*/, delay_1.default(1000)];
                    case 1:
                        // TODO: connect to endpoint
                        _b.sent();
                        if (!this.getProfileId) {
                            throw new Error("No Profile ID found attached to User");
                        }
                        _a = this;
                        return [4 /*yield*/, __1.Driver.fetch(this.getProfileId)];
                    case 2:
                        _a.profile = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.fetchSubco = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // TODO: connect to endpoint
                    return [4 /*yield*/, delay_1.default(1000)];
                    case 1:
                        // TODO: connect to endpoint
                        _b.sent();
                        if (!this.getProfileId) {
                            throw new Error("No Profile ID found attached to User");
                        }
                        _a = this;
                        return [4 /*yield*/, __1.Subco.fetch(this.getProfileId)];
                    case 2:
                        _a.profile = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.fetchProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.getType;
                        switch (_a) {
                            case "DRIVER" /* DRIVER */: return [3 /*break*/, 1];
                            case "SUBCONTRACTOR" /* SUBCONTRACTOR */: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, this.fetchDriver()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.fetchSubco()];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5: throw new Error("Can't fetch a profile for user type: " + this.getType);
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.setId = id;
        this.setType = type;
        this.setProfileId = profileId;
        this.setUserSub = userSub;
    }
    Object.defineProperty(User.prototype, "getId", {
        /**
         * GETTERS
         */
        get: function () {
            return this.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "getType", {
        get: function () {
            return this.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "getUserSub", {
        get: function () {
            return this.userSub;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "getProfileId", {
        get: function () {
            return this.profileId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "getProfile", {
        get: function () {
            var _this = this;
            if (!this.profile) {
                return this.fetchProfile().then(function () { return _this.profile; });
            }
            return Promise.resolve(this.profile);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "setId", {
        /**
         * SETTERS
         */
        set: function (id) {
            this.id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "setType", {
        set: function (type) {
            this.type = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "setUserSub", {
        set: function (userSub) {
            this.userSub = userSub;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "setProfileId", {
        set: function (profileId) {
            this.profileId = profileId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "setProfile", {
        set: function (profile) {
            this.profile = profile;
        },
        enumerable: true,
        configurable: true
    });
    User.fetch = function (userSub) { return __awaiter(_this, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // TODO: connect to endpoint
                return [4 /*yield*/, delay_1.default(1000)];
                case 1:
                    // TODO: connect to endpoint
                    _a.sent();
                    user = __1.mockUsers.find(function (item) { return item.userSub === userSub; });
                    if (!user) {
                        throw new Error("User not found");
                    }
                    return [2 /*return*/, new User(user.id, user.type, user.profileId, user.userSub)];
            }
        });
    }); };
    User.fetchByDriverId = function (driverId) { return __awaiter(_this, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // TODO: connect to endpoint
                return [4 /*yield*/, delay_1.default(1000)];
                case 1:
                    // TODO: connect to endpoint
                    _a.sent();
                    user = __1.mockUsers.find(function (item) { return item.profileId === driverId && item.type === "DRIVER" /* DRIVER */; });
                    if (!user) {
                        throw new Error("User not found");
                    }
                    return [2 /*return*/, new User(user.id, user.type, user.profileId, user.userSub)];
            }
        });
    }); };
    User.fetchBySubcoId = function (subcoId) { return __awaiter(_this, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // TODO: connect to endpoint
                return [4 /*yield*/, delay_1.default(1000)];
                case 1:
                    // TODO: connect to endpoint
                    _a.sent();
                    user = __1.mockUsers.find(function (item) {
                        return item.profileId === subcoId && item.type === "SUBCONTRACTOR" /* SUBCONTRACTOR */;
                    });
                    if (!user) {
                        throw new Error("User not found");
                    }
                    return [2 /*return*/, new User(user.id, user.type, user.profileId, user.userSub)];
            }
        });
    }); };
    return User;
}());
exports.User = User;
